module.exports = __webpack_public_path__ + "static/img/brand-7.0f63de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-7.png
// module id = 9UvY
// module chunks = 0